export default function OnboardingTour() {
  return null;
}
